import NewRequest from '@/utils/loginRequest'
// 登录
export function loginApi(data) {
  data = Object.assign(
    { login_type: 2, token: '', plat: 0, tel: '', tel_code: '' },
    data,
  )
  // http://apix.kisops.com/project/750/interface/api/27719
  return NewRequest.post('/api/sdk/user/login', data)
}

// 发送手机验证码
export function sendVerifyCode(data) {
  return NewRequest.post('/api/sdk/sms/send_code', data)
}

// 获取图形验证码
export function getCaptchaApi(data) {
  return NewRequest.post('/api/sdk/sms/captcha', data)
}

// 校验图形验证码
export function checkCaptchaApi(data) {
  return NewRequest.post('/api/sdk/sms/captcha_check', data)
}

export function getToken(data) {
  return NewRequest.post('/api/sdk/user/token', data)
}
